import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { useUser } from '@clerk/clerk-react';
import {
  API_KEY,
  API_POSTS,
  API_POSTS_DELETE,
  API_CLIENTS_NAME,
  API_POSTS_MONTH,
  API_POSTS_EDIT,
  API_GENERATE_AI_POST,
  API_GET_CONTENT_STRATEGIES,
  API_GET_PROMPTS,
  MONTHS_TO_GENERATE,
  API_GENERATE_AI_POST_V2,
  API_GENERATE_AI_POST_V2_NO_AI
} from '../../utils';
import Countdown from './counter';

import ViewPostsInCalendar from '../../components/ViewPostsInCalendar';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeline from '@fullcalendar/timeline';
import list from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import Select from 'react-select';
import { Link, useHistory, useLocation } from 'react-router-dom';
import Clock from 'react-live-clock';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '../../components/ui/card';
import { Checkbox } from '../../components/ui/checkbox';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '../../components/ui/dialog';
import {
  Menu,
  Calendar as CalendarIcon,
  ChevronLeft,
  ChevronRight,
  Image,
  Sparkles,
  Trash2,
  Wand2,
  Lightbulb,
  Search,
  Plus
} from 'lucide-react';
import { postsSelector, setSelectedPost } from '../../store/slices/posts';
import { clientsSelector, getClients } from '../../store/slices/clients';
import {
  setSelectedClient,
  selectedClientSelector
} from '../../store/slices/selectedClient';
import { setNewPostData } from '../../store/slices/newPost';

import { authSelector } from '../../store/slices/auth';
import * as Theme from '../../theme/theme';
import './Calendar.scss';
import './Modal-calendar.css';
import CalendarSkeleton from './CalendarSkeleton';

import {
  resetContentState,
  generateContent as showLoadingModal
} from '../../store/slices/generalState';
import { showLoading, hideLoading } from '../../store/slices/loadingState';

import { useSidebar } from '../../contexts/SidebarContext';
import LoadingSpinner from '../../pages/Calendar/GallerySection/StockImagesComponents/Partials/LoadingSpinner';
import TooltipInfo from '../Client/TooltipInfo/tooltipInfo';

const moment = require('moment-timezone');
const axios = require('axios');

function CalendarScreen() {
  const viewPostRef = useRef(null);
  const userGalleryRef = useRef(null);
  const iAPostToolsRef = useRef(null);
  const calendarRef = useRef(null);
  const pendingNavigationDate = useRef(null);
  const history = useHistory();
  const { user } = useUser();
  const [imagesLimit, setImagesLimit] = useState(3);
  const [refresh, setRefresh] = useState(true);
  const { customerList } = useSelector(clientsSelector);
  const { selectedClient } = useSelector(selectedClientSelector);
  const { selectedPost } = useSelector(postsSelector);
  const [loadingPosts, SetLoadingPosts] = useState(undefined);
  const [initialLoading, setInitialLoading] = useState(true);
  const [postsLists, SetPostsLists] = useState([]);
  const [listSelectedToDelete, setListSelectedToDelete] = useState([]);
  const [listSelectedtoSwitch, setListSelectedtoSwitch] = useState([]);
  const [queryDate, setQueryDate] = useState(
    `${new Date().getMonth() + 1} ${new Date().getFullYear()}`
  );
  const [checkDeleteMultiple, setCheckDeleteMultiple] = useState(false);
  const [checkSwitchMultiple, setCheckSwitchMultiple] = useState(false);
  const dispatch = useDispatch();
  const { userInfo } = useSelector(authSelector);

  // Obtener email y rol del usuario autenticado de Clerk
  const currentEmail = user?.primaryEmailAddress?.emailAddress || '';
  const currentRole =
    currentEmail.endsWith('@adlerlocal.com') ||
    currentEmail.endsWith('@samxlabs.com') ||
    currentEmail.endsWith('@adlersocial.com')
      ? 'admin'
      : 'user';
  const [refresh2, setRefresh2] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [blockingClientId, setBlockingClientId] = useState(null);
  const [generationStartTime, setGenerationStartTime] = useState(null);
  const [showPrompts, setShowPrompts] = useState(false);
  const [contentStrategy, setContentStrategy] = useState({});
  const [showImages, setShowImages] = useState(true);
  const [clientNavigationMode, setClientNavigationMode] = useState('all');
  const [isContentAgentProcessing, setIsContentAgentProcessing] =
    useState(false);

  // Determine if user is superAdmin based on domain
  const userEmail = user?.primaryEmailAddress?.emailAddress || '';
  const isSuperAdmin =
    userEmail.endsWith('@adlerlocal.com') ||
    userEmail.endsWith('@adlersocial.com') ||
    userEmail.endsWith('@samxlabs.com');

  // Check if user has "pro" plan in public metadata
  const hasProPlan = user?.publicMetadata?.plan === 'pro';

  // Modal visibility state
  const [contentStrategyName, setContentStrategyName] = useState('');
  const [showViewPostModal, setShowViewPostModal] = useState(false);
  const [showAIToolsModal, setShowAIToolsModal] = useState(false);
  const { sidebarOpen, setSidebarOpen } = useSidebar();
  const [deleteSuccessModalOpen, setDeleteSuccessModalOpen] = useState(false);
  const [updateSuccessModalOpen, setUpdateSuccessModalOpen] = useState(false);
  const [scheduleErrorModalOpen, setScheduleErrorModalOpen] = useState(false);
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [updateConfirmModalOpen, setUpdateConfirmModalOpen] = useState(false);
  const [postSentSuccessModalOpen, setPostSentSuccessModalOpen] =
    useState(false);
  const location = useLocation();

  // Removed Bootstrap Tooltip initialization - use CSS title attribute or ShadCN Tooltip instead

  useEffect(() => {
    if (showPrompts) {
      axios
        .get(
          `${API_GET_CONTENT_STRATEGIES}?id=${selectedClient?.contentStrategy}`,
          {}
        )
        .then((res) => {
          setContentStrategy(res?.data?.contentStrategies);
        });
    }
  }, [showPrompts, selectedClient?.id, selectedClient?.contentStrategy]);

  useEffect(() => {
    axios
      .get(
        `${API_GET_CONTENT_STRATEGIES}?id=${selectedClient?.contentStrategy}`,
        {}
      )
      .then((res) => {
        setContentStrategyName(res?.data?.contentStrategies?.strategyName);
      });
  }, [selectedClient?.contentStrategy]);

  useEffect(() => {
    setShowPrompts(false);
  }, [selectedClient?.id]);

  useEffect(() => {
    if (customerList.length === 0) {
      dispatch(getClients());
    }
  }, []);

  // Detectar si se viene de NewPost con éxito
  useEffect(() => {
    if (location.state?.showSuccessModal) {
      setPostSentSuccessModalOpen(true);
      if (location.state?.postDate) {
        // postDate is a Unix timestamp in seconds, convert to ms for Date
        pendingNavigationDate.current = new Date(
          location.state.postDate * 1000
        );
      }
      // Limpiar el estado para que no se muestre de nuevo al recargar
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleShowPrompts = () => {
    SetPostsLists([]);

    setShowPrompts(!showPrompts);
  };

  const handleChangeClient = async (x) => {
    try {
      // Fetch complete client data from API to ensure all attributes are present
      const response = await axios.get(`${API_CLIENTS_NAME}${x.clientName}`, {
        headers: {
          'X-API-KEY': API_KEY,
          Authorization: `bearer ${userInfo.accessToken}`
        }
      });

      if (response?.data) {
        // Dispatch the complete client data with all attributes including socialnetworks
        dispatch(setSelectedClient(response.data));
      } else {
        // Fallback to using the client from customerList if API call returns no data
        dispatch(setSelectedClient(x));
      }
    } catch (error) {
      console.error('Error fetching complete client data:', error);
      // Fallback to using the client from customerList if API call fails
      dispatch(setSelectedClient(x));
    }

    setImagesLimit(3);
    history.push(`/calendar`);
  };

  const hasNoAIFlag = (customer) => {
    const flags = customer?.clientFlags;
    if (Array.isArray(flags)) {
      return flags.includes('NO_AI');
    }
    if (typeof flags === 'string') {
      return flags
        .split(',')
        .map((flag) => flag.trim())
        .includes('NO_AI');
    }
    return false;
  };

  const noAIClientList = useMemo(
    () => customerList.filter((customer) => hasNoAIFlag(customer)),
    [customerList]
  );

  const navigableCustomerList =
    clientNavigationMode === 'no_ai' ? noAIClientList : customerList;

  const searchableCustomerList = useMemo(
    () =>
      navigableCustomerList.map((customer) => ({
        ...customer,
        label: customer.clientName,
        value: customer.clientName
      })),
    [navigableCustomerList]
  );

  useEffect(() => {
    if (clientNavigationMode !== 'no_ai') return;
    if (!selectedClient?.id) return;
    if (hasNoAIFlag(selectedClient)) return;
    if (!noAIClientList.length) return;

    handleChangeClient(noAIClientList[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientNavigationMode, selectedClient?.id, noAIClientList]);

  const handleShowImages = () => {
    setShowImages(!showImages);
    // Force calendar re-render to apply/remove show-images-mode styles
    setTimeout(() => {
      if (calendarRef.current) {
        calendarRef.current.render();
      }
    }, 100);
  };

  // Client is already loaded from Redux selectedClient state
  // No need to fetch from URL parameter

  useEffect(() => {
    if (queryDate && selectedClient?.id) {
      fetchPosts(queryDate);
    }

    // eslint-disable-next-line
  }, [queryDate, selectedClient, showPrompts]);

  useEffect(() => {
    setRefresh2(!refresh2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postsLists]);

  // Navigate to the post's scheduled month after the calendar finishes loading
  useEffect(() => {
    if (!initialLoading && pendingNavigationDate.current) {
      const date = pendingNavigationDate.current;
      pendingNavigationDate.current = null;
      setTimeout(() => {
        calendarRef.current?.getApi().gotoDate(date);
      }, 0);
    }
  }, [initialLoading]);

  const checkDeleteMultipleState = () => {
    setCheckDeleteMultiple(!checkDeleteMultiple);
    setListSelectedToDelete([]);
    if (checkDeleteMultiple === false) {
      setListSelectedToDelete([]);
      // Desactivar el otro checkbox
      setCheckSwitchMultiple(false);
      setListSelectedtoSwitch([]);
    }
  };

  const checkSwitchMultipleState = () => {
    setCheckSwitchMultiple(!checkSwitchMultiple);
    setListSelectedtoSwitch([]);
    if (checkSwitchMultiple === false) {
      setListSelectedtoSwitch([]);
      // Desactivar el otro checkbox
      setCheckDeleteMultiple(false);
      setListSelectedToDelete([]);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchPosts = async (date) => {
    try {
      if (!selectedClient?.id) return [];
      let arr = date.split(' ');
      const month = Number(arr[0]);
      const year = Number(arr[1]);
      let dateNow = {
        year: year.toString(),
        month: month.toString(),
        clientId: selectedClient.id
      };
      dispatch(showLoading());
      SetLoadingPosts(true);
      // HERE WE ASK FOR POSTS
      let res = showPrompts
        ? await axios.request({
            method: 'post',
            url: API_GET_PROMPTS,
            data: {
              csId: selectedClient?.clientGroups?.[0]?.id,
              clId: selectedClient.id,
              timeZone:
                selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)',
              month: dateNow.month,
              year: dateNow.year
            }
          })
        : await axios.post(API_POSTS_MONTH, {
            ...dateNow,
            timeZone:
              selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)'
          });

      //
      SetPostsLists(showPrompts ? res.data.mergedArray : res.data.posts);
      dispatch(hideLoading());
      if (!selectedClient.firstGenerationByAI) {
        SetLoadingPosts(false);
      }
      setInitialLoading(false);
      return showPrompts ? res.data.mergedArray : res.data.posts;
    } catch (error) {
      console.error(error);
      setInitialLoading(false);
    }
  };

  const getTime = (currentClientTimeZone, datePost) => {
    let date = null;
    switch (currentClientTimeZone) {
      case 'Eastern Daylight Time - (GMT-4)':
        date = moment(datePost)
          .tz('America/New_York')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Central Daylight Time - (GMT-5)':
        date = moment(datePost)
          .tz('America/Chicago')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Mountain Daylight Time - (GMT-6)':
        date = moment(datePost).tz('America/Denver').format('YYYY-MM-DDTHH:mm');
        break;
      case 'Mountain Standard Time - (GMT-7)':
        date = moment(datePost)
          .tz('America/Phoenix')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Pacific Daylight Time - (GMT-7)':
        date = moment(datePost)
          .tz('America/Los_Angeles')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Alaska Daylight Time - (GMT-8)':
        date = moment(datePost)
          .tz('America/Anchorage')
          .format('YYYY-MM-DDTHH:mm');
        break;
      default:
        date = moment(datePost)
          .tz('Pacific/Honolulu')
          .format('YYYY-MM-DDTHH:mm');
        break;
    }
    return date;
  };

  const onSelectPost = (event, forced) => {
    if (event.view.type === 'listMonth' && !forced) return;
    let obj = event.event;
    if (!(checkDeleteMultiple || checkSwitchMultiple)) {
      let images = obj._def.extendedProps.images;
      let post = {
        id: obj.id,
        title: obj.title,
        start: obj.start,
        backgroundColor: obj.backgroundColor,
        images: images,
        client: selectedClient,
        socialNetworks: obj._def.extendedProps.socialNetworks,
        status: obj._def.extendedProps.status,
        createdBy: obj._def.extendedProps.createdBy,
        createdAt: obj._def.extendedProps.createdAt,
        hashtagsig: obj._def.extendedProps.hashtagsig,
        SK: obj._def.extendedProps.SK,
        updatedAt: obj._def.extendedProps.updatedAt,
        editedBy: obj._def.extendedProps.editedBy,
        isPromotional: obj._def.extendedProps.isPromotional,
        isOffer: obj._def.extendedProps.isOffer,
        tiktok: obj._def.extendedProps.tiktok || null
      };
      dispatch(setSelectedPost(post));
      if (event.oldEvent === undefined) {
        // Show view post modal using React state
        setShowViewPostModal(true);
      } else {
        editPost(post);
      }
    } else {
      if (
        (obj.extendedProps.status === 'Schedule' ||
          obj.extendedProps.status === 'Draft' ||
          obj.extendedProps.status === 'Promo') &&
        checkDeleteMultiple
      ) {
        if (listSelectedToDelete.indexOf(obj.id) === -1) {
          setListSelectedToDelete([...listSelectedToDelete, obj.id]);
        } else {
          let index = listSelectedToDelete.indexOf(obj.id);
          if (index > -1) {
            setListSelectedToDelete((listSelectedToDelete) =>
              listSelectedToDelete.filter((img, i) => i !== index)
            );
          }
        }
      } else if (
        (obj.extendedProps.status === 'Schedule' ||
          obj.extendedProps.status === 'Draft') &&
        checkSwitchMultiple
      ) {
        if (listSelectedtoSwitch.indexOf(obj.id) === -1) {
          setListSelectedtoSwitch([...listSelectedtoSwitch, obj.id]);
        } else {
          let index = listSelectedtoSwitch.indexOf(obj.id);
          if (index > -1) {
            setListSelectedtoSwitch((listSelectedtoSwitch) =>
              listSelectedtoSwitch.filter((img, i) => i !== index)
            );
          }
        }
      }
    }
  };
  const getStatusPost = async (id) => {
    if (queryDate && selectedClient?.id) {
      await fetchPosts(queryDate);
      const isSameId = (element) => element.id === id;
      const idx = postsLists.findIndex(isSameId);
      const post = { ...postsLists[idx], isDraft: false };
      dispatch(setSelectedPost(post));
    }
  };
  const getCalendarDate = async (
    fetchInfo,
    successCallback,
    failureCallback
  ) => {
    setQueryDate(
      `${new Date(fetchInfo.start).getMonth() + 1} ${new Date(
        fetchInfo.start
      ).getFullYear()}`
    );
    let postToCalendar = postsLists.map((post) => {
      let datePost = post.schedule || post.createdAt;
      let isDraft = post.isDraft;
      let datePost2 = moment.unix(datePost).format('YYYY-MM-DDTHH:mm');
      let dateNow = moment.utc(new Date()).unix();
      let statusPost = { status: 0, selected: checkDeleteMultiple };
      let valuesPost = {};
      let hashtagsig = post?.hashtagsig;
      if (isDraft) {
        statusPost.status = 2; // DRAFT
      } else if (post.createdBy === 'APP') {
        statusPost.status = 3; // APP
      } else if (post?.prompt) {
        statusPost.status = 4; // PROMPT
      } else if (post?.isPromotional) {
        statusPost.status = 5; // PROMOTIONAL
      } else if (post?.isOffer) {
        statusPost.status = 6; // OFFER
      } else {
        statusPost.status = datePost > dateNow - 10 ? 1 : 0; //0 posted | 1 schedule
      }

      switch (true) {
        case statusPost.status === 0: // posted Status
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Posted';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.postedColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.postedColor;
          break;

        case statusPost.status === 1: // scheduled Status
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Schedule';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.scheduledColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : listSelectedtoSwitch.includes(post.id) && checkSwitchMultiple
              ? Theme.infoColor
              : Theme.scheduledColor;
          break;

        case statusPost.status === 3: // APP Status
          valuesPost['startEditable'] =
            checkDeleteMultiple || checkSwitchMultiple ? false : true;
          valuesPost['status'] = 'App';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.appColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.appColor;
          break;
        case statusPost.status === 4:
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Prompt';
          valuesPost['borderColor'] = Theme.promptColor;
          valuesPost['backgroundColor'] = Theme.promptColor;
          break;

        case statusPost.status === 5:
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Promo';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.promoColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.promoColor;
          break;

        case statusPost.status === 6:
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Offer';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.offerColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.offerColor;
          break;

        default:
          // Draft Status
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Draft';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.draftColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : listSelectedtoSwitch.includes(post.id) && checkSwitchMultiple
              ? Theme.infoColor
              : Theme.draftColor;
          break;
      }
      let start = getTime(
        selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)',
        datePost2
      );
      return {
        id: post.id,
        title: post.message,
        start: start,
        startEditable: valuesPost['startEditable'],
        status: valuesPost['status'],
        borderColor: valuesPost['borderColor'],
        backgroundColor: valuesPost['backgroundColor'],
        textColor: '#fff',
        images: post.images,
        socialNetworks: post.socialNetworks,
        tiktok: post.tiktok || null,
        createdBy: post.createdBy,
        createdAt: post.createdAt,
        hashtagsig: hashtagsig,
        SK: post?.SK,
        updatedAt: post?.updatedAt,
        editedBy: post?.editedBy
      };
    });
    successCallback(postToCalendar);
  };

  const handleClickIATools = () => {
    setShowAIToolsModal(true);
  };

  const handleDateClick = (arg) => {
    if (checkDeleteMultiple || checkSwitchMultiple || !hasProPlan) {
      return;
    }
    var current = new Date(
      getTime(selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)')
    );

    var onNewPost = {
      title: '',
      start: new Date(
        arg.date.setHours(current.getHours(), current.getMinutes())
      ),
      allDay: false,
      backgroundColor: Theme.scheduledColor,
      borderColor: '#0168fa',
      textColor: '#fff'
    };

    // Set data in Redux and navigate to new page
    dispatch(
      setNewPostData({
        show: true,
        post: onNewPost,
        hideRecurrent: true,
        isCalendar: true,
        currentClientId: selectedClient.id,
        currentClientSocialNetworks: selectedClient.clientSocialNetworks || {},
        currentClientTimeZone:
          selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)',
        currentClientBestTimes: selectedClient.bestTimes || {},
        currentClientMergeFields: selectedClient.mergeFields || {},
        currentCustomerName: userInfo?.displayName
      })
    );

    history.push('/new-post');
  };

  const handleCreateNewPost = () => {
    // Crear fecha con una hora más tarde
    const currentTime = new Date(
      getTime(selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)')
    );
    const oneHourLater = new Date(currentTime.getTime() + 60 * 60 * 1000);

    const newPost = {
      title: '',
      start: oneHourLater,
      allDay: false,
      backgroundColor: Theme.scheduledColor,
      borderColor: '#0168fa',
      textColor: '#fff'
    };

    // Set data in Redux and navigate to new page
    dispatch(
      setNewPostData({
        show: true,
        post: newPost,
        hideRecurrent: true,
        isCalendar: true,
        currentClientId: selectedClient.id,
        currentClientSocialNetworks: selectedClient.clientSocialNetworks || {},
        currentClientTimeZone:
          selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)',
        currentClientBestTimes: selectedClient.bestTimes || {},
        currentClientMergeFields: selectedClient.mergeFields || {},
        currentCustomerName: userInfo?.displayName
      })
    );

    history.push('/new-post');
  };
  const editPost = (post) => {
    dispatch(
      setNewPostData({
        show: true,
        post: post,
        hideRecurrent: true,
        isCalendar: true,
        currentClientId: selectedClient.id,
        currentClientSocialNetworks: selectedClient.clientSocialNetworks || {},
        currentClientTimeZone:
          selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)',
        currentClientBestTimes: selectedClient.bestTimes || {},
        currentClientMergeFields: selectedClient.mergeFields || {},
        currentCustomerName: userInfo?.displayName
      })
    );

    history.push('/new-post');
  };
  const rePost = (post) => {
    let data = {};
    let socialNetwork = {};
    Object.assign(data, post);
    delete data.id;
    data.status = 'Schedule';
    Object.assign(socialNetwork, data.socialNetworks);
    if (data.socialNetworks.facebookPosted === true) {
      socialNetwork.facebook = false;
    }
    if (data.socialNetworks.twitterPosted === true) {
      socialNetwork.twitter = false;
    }
    if (data.socialNetworks.instagramPosted === true) {
      socialNetwork.instagram = false;
    }
    if (data.socialNetworks.googleMyBusinessPosted === true) {
      socialNetwork.googleMyBusiness = false;
    }
    if (data.socialNetworks.tiktokPosted === true) {
      socialNetwork.tiktok = false;
    }
    data.socialNetworks = socialNetwork;

    dispatch(
      setNewPostData({
        show: true,
        post: data,
        hideRecurrent: true,
        isCalendar: true,
        currentClientId: selectedClient.id,
        currentClientSocialNetworks: selectedClient.clientSocialNetworks || {},
        currentClientTimeZone:
          selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)',
        currentClientBestTimes: selectedClient.bestTimes || {},
        currentClientMergeFields: selectedClient.mergeFields || {},
        currentCustomerName: userInfo?.displayName
      })
    );

    history.push('/new-post');
  };

  const repairPost = (post) => {
    let data = {};
    Object.assign(data, post);
    data.status = 'Schedule';
    data.isRepairingPost = true;

    dispatch(
      setNewPostData({
        show: true,
        post: data,
        hideRecurrent: true,
        isCalendar: true,
        currentClientId: selectedClient.id,
        currentClientSocialNetworks: selectedClient.clientSocialNetworks || {},
        currentClientTimeZone:
          selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)',
        currentClientBestTimes: selectedClient.bestTimes || {},
        currentClientMergeFields: selectedClient.mergeFields || {},
        currentCustomerName: userInfo?.displayName
      })
    );

    history.push('/new-post');
  };

  const deletePost = async (id, options) => {
    const clerkUserDisplayName = user?.firstName
      ? `${user.firstName}${user.lastName ? ' ' + user.lastName : ''}`
      : currentEmail;

    await axios
      .post(API_POSTS_DELETE, {
        postId: id,
        clientId: selectedClient.id,
        deletedBy: {
          displayName: clerkUserDisplayName,
          email: currentEmail,
          role: currentRole
        },
        options: options
      })
      .then((response) => {
        if (response.status === 200) {
          fetchPosts(queryDate);
        }
      });
  };

  const updatePost = (id) => {
    const isSameId = (element) => element.id === id;
    const idx = postsLists.findIndex(isSameId);
    const post = {
      ...postsLists[idx],
      createdBy: userInfo?.displayName,
      isDraft: !postsLists[idx].isDraft,
      posted: false,
      isScheduled: false
    };
    axios
      .post(API_POSTS_EDIT, JSON.stringify(post))
      .then((response) => {
        fetchPosts(queryDate);
      })
      .catch((error) => {
        fetchPosts(queryDate);
        if (error) {
          setScheduleErrorModalOpen(true);
        }
        console.error(error);
      });
  };

  const updatePostsMultiple = () => {
    if (listSelectedtoSwitch.length === 0) return;
    setUpdateConfirmModalOpen(true);
  };

  const confirmUpdatePostsMultiple = () => {
    listSelectedtoSwitch.forEach((idPost) => {
      updatePost(idPost);
    });
    setListSelectedtoSwitch([]);
    setCheckSwitchMultiple(false);
    setUpdateConfirmModalOpen(false);
  };

  const deletePostMultiple = (options) => {
    if (listSelectedToDelete.length === 0) return;
    setDeleteConfirmModalOpen(true);
  };

  const confirmDeletePostMultiple = () => {
    listSelectedToDelete.forEach((idPost) => {
      deletePost(idPost, null);
    });
    setListSelectedToDelete([]);
    setCheckDeleteMultiple(false);
    setDeleteConfirmModalOpen(false);
  };

  const carrouselModal = async (x, id) => {
    let idx = 0;
    for (
      idx = 0;
      idx < postsLists.length && selectedPost.id !== postsLists[idx].id;
      idx++
    );

    if (x === 1) {
      if (idx < postsLists.length - 1) {
        idx += 1;
      }
    } else if (x === 0) {
      if (idx > 0) {
        idx -= 1;
      }
    }
    let obj = postsLists[idx];
    if (x === 8) {
      let posts = await fetchPosts(queryDate);
      idx = 0;
      function findIndexByCondition(array, conditionFunction) {
        for (let i = 0; i < array.length; i++) {
          if (conditionFunction(array[i])) {
            return i; // Return the index when the condition is met
          }
        }
        return -1; // If no element is found that meets the condition
      }
      const condition = (item) => item.id === id;
      idx = findIndexByCondition(posts, condition);

      obj = posts[idx];
    }

    let statCurrPost = '';
    let colorBackground = '';
    let datePost = obj?.schedule || obj?.createdAt;
    let dateNow = moment.utc(new Date()).unix();
    if (obj?.isDraft) {
      statCurrPost = 'Draft'; //Draft
      colorBackground = '#7987a1';
    } else if (obj?.createdBy === 'APP') {
      statCurrPost = 'App';
      colorBackground = Theme.appColor;
    } else if (showPrompts) {
      statCurrPost = 'Prompt';
    } else if (obj?.isPromotional) {
      statCurrPost = 'Promo';
    } else if (obj?.isOffer) {
      statCurrPost = 'Offer';
    } else {
      statCurrPost = datePost > dateNow - 10 ? 'Schedule' : 'Posted'; //0 posted | 1 schedule
      colorBackground =
        statCurrPost === 'Posted' ? Theme.postedColor : Theme.scheduledColor;
    }

    let post = {
      id: obj?.id || id,
      title: obj?.message,
      start: obj?.schedule,
      backgroundColor: colorBackground,
      images: obj?.images,
      client: selectedClient,
      socialNetworks: obj?.socialNetworks,
      status: statCurrPost,
      createdBy: obj?.createdBy,
      createdAt: obj?.createdAt,
      hashtagsig: obj?.hashtagsig,
      SK: obj?.SK,
      updatedAt: obj?.updatedAt,
      editedBy: obj?.editedBy
    };
    dispatch(setSelectedPost(post));
  };

  let newUrl;
  if (selectedClient !== null) {
    newUrl = selectedClient.clientName
      .replace(/\s+/g, '%20')
      .replace(/\//g, '%2F')
      .replace(/'/g, '%1D')
      .replace(/’/g, '%1E');
  }

  useEffect(() => {
    if (blockingClientId && blockingClientId !== selectedClient?.id) {
      setIsGenerating(false);
      SetLoadingPosts(false);
      setBlockingClientId(null);
      setGenerationStartTime(null);
    }
  }, [selectedClient?.id, blockingClientId]);

  useEffect(() => {
    if (!isGenerating || !selectedClient?.clientName) return;
    let cancelled = false;
    const interval = setInterval(async () => {
      if (cancelled) return;
      try {
        const client = await axios.get(
          `${API_CLIENTS_NAME}${selectedClient.clientName}`,
          {
            headers: {
              'X-API-KEY': API_KEY,
              Authorization: `bearer ${userInfo.accessToken}`
            }
          }
        );
        if (client?.data) {
          dispatch(setSelectedClient(client.data));
        }
      } catch (e) {}
    }, 10000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGenerating, selectedClient?.clientName]);

  // Clear block if generatingContentByAI changes to false
  useEffect(() => {
    if (
      selectedClient?.generatingContentByAI === false &&
      isGenerating &&
      blockingClientId === selectedClient?.id
    ) {
      // If generatingContentByAI changes to false, clear the block
      setIsGenerating(false);
      SetLoadingPosts(false);
      setBlockingClientId(null);
      setGenerationStartTime(null);
    }
  }, [
    selectedClient?.generatingContentByAI,
    isGenerating,
    blockingClientId,
    selectedClient?.id
  ]);

  // Restore generating state if the page was reloaded while generation was in progress
  useEffect(() => {
    if (selectedClient?.generatingContentByAI === true && !isGenerating) {
      setIsGenerating(true);
      SetLoadingPosts(true);
      setBlockingClientId(selectedClient.id);
      setGenerationStartTime(
        selectedClient.generationStartedAt ||
          selectedClient.createdAt ||
          Date.now()
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClient?.generatingContentByAI, selectedClient?.id, isGenerating]);

  useEffect(() => {
    const applyTodayStyles = () => {
      const todayElements = document.querySelectorAll(
        '.fc-day-today .fc-daygrid-day-number'
      );
      todayElements.forEach((element) => {
        element.style.cssText = `
          background-color: #007bff !important;
          color: white !important;
          border-radius: 4px !important;
          width: 20px !important;
          height: 20px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          position: absolute !important;
          top: 2px !important;
          right: 2px !important;
          z-index: 10 !important;
          font-size: 10px !important;
          font-weight: 600 !important;
          min-width: 20px !important;
          min-height: 20px !important;
          padding: 0 !important;
          line-height: 1 !important;
          box-sizing: border-box !important;
        `;
      });
    };
  }, [selectedClient, postsLists]);

  useEffect(() => {
    if (!selectedClient?.clientName) return;

    if (typeof Storage !== 'undefined') {
      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      const currentDay = today.getDate();

      const yesterday = new Date(localStorage.getItem('prevDate'));
      const prevMonth = yesterday.getMonth() + 1;
      const prevDay = yesterday.getDate();

      if (
        currentMonth !== prevMonth ||
        currentDay !== prevDay ||
        !localStorage.getItem('prevDate')
      ) {
        localStorage.setItem('prevDate', today.toDateString());
        localStorage.removeItem('notes');
      }
    }

    if (!localStorage.getItem('notes')) {
      const clientsNotices = [];
      if (selectedClient.clientName !== '') {
        clientsNotices.push(selectedClient.clientName);
      }
      localStorage.setItem('notes', JSON.stringify(clientsNotices));
      return;
    }

    const clientsNotices = JSON.parse(localStorage.getItem('notes'));
    if (!clientsNotices.includes(selectedClient.clientName)) {
      clientsNotices.push(selectedClient.clientName);
      localStorage.setItem('notes', JSON.stringify(clientsNotices));
      return;
    }
  }, [selectedClient]);

  const CustomListContent = (props) => {
    let post = props.obj.extendedProps;
    let id = props.obj.id;
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%'
        }}>
        {post.images && post.images[0] && (
          <img
            style={{
              maxWidth: '260px',
              maxHeight: '130px',
              margin: '15px',
              objectFit: 'cover',
              borderRadius: '4px'
            }}
            src={post.images[0].url}
            alt="Post image"
          />
        )}
        <div
          style={{
            height: '90px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            marginLeft: '15px'
          }}>
          <div
            className="button-like-a nav-link"
            onClick={() => {
              onSelectPost(props.ev, true);
            }}>
            <i class="fas fa-eye fa-lg"></i>
          </div>
          {(post.status === 'Schedule' || post.status === 'Draft') &&
          !checkDeleteMultiple &&
          !checkSwitchMultiple ? (
            <>
              <div
                className="button-like-a nav-link"
                onClick={() => {
                  updatePost(id);
                }}>
                <i className="fas fa-lg fa-magic" />
              </div>
            </>
          ) : (
            <div
              style={{
                width: '50px'
              }}></div>
          )}
        </div>
      </div>
    );
  };

  // Show skeleton if client is not loaded yet or initial loading
  if (!selectedClient || initialLoading) {
    return <CalendarSkeleton sidebarOpen={sidebarOpen} />;
  }

  return (
    <>
      <main className="p-3 sm:p-6 lg:p-10 space-y-4 sm:space-y-8">
        {/* Page Title */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3 sm:gap-4 mb-2 sm:mb-4">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-foreground">
                Social Media, {selectedClient ? selectedClient.clientName : ''}
              </h1>
              {hasProPlan && (
                <TooltipInfo
                  accountOwner={selectedClient.accountOwner}
                  accountStatus={selectedClient.accountStatus}
                  clientFlags={selectedClient.clientFlags}
                />
              )}
            </div>
            <p className="text-sm sm:text-base text-muted-foreground mt-0.5 sm:mt-1">
              Schedule and manage your social media posts
            </p>
          </div>
          <div className="flex flex-col items-start sm:items-end gap-2">
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 w-full sm:w-auto">
              {/* Client navigation */}
              {isSuperAdmin && (
                <div className="relative w-full sm:w-72">
                  <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground z-10" />
                  <Select
                    placeholder="Search"
                    onChange={(client) => handleChangeClient(client)}
                    options={searchableCustomerList}
                    hideSelectedOptions={true}
                    controlShouldRenderValue={false}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null
                    }}
                    openMenuOnClick={false}
                    openMenuOnFocus={false}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (provided, state) => ({
                        ...provided,
                        borderRadius: '0.75rem',
                        borderWidth: '1px',
                        borderColor: state.isFocused
                          ? 'hsl(var(--primary))'
                          : 'hsl(var(--border))',
                        boxShadow: state.isFocused
                          ? '0 0 0 1px hsl(var(--primary))'
                          : 'none',
                        backgroundColor: '#ffffff',
                        paddingTop: '10px',
                        paddingBottom: '9px',
                        paddingLeft: '2.5rem',
                        fontSize: '1rem',
                        width: '100%',
                        '&:hover': {
                          borderColor: 'hsl(var(--primary))'
                        }
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: 'hsl(var(--muted-foreground))',
                        fontSize: '1rem'
                      }),
                      input: (provided) => ({
                        ...provided,
                        fontSize: '1rem',
                        color: 'hsl(var(--foreground))'
                      }),
                      menu: (provided) => ({
                        ...provided,
                        borderRadius: '0.75rem',
                        overflow: 'hidden',
                        boxShadow:
                          '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#f1f5f9' : 'white',
                        color: state.isFocused ? '#1e293b' : '#64748b',
                        cursor: 'pointer',
                        padding: '12px 16px',
                        fontSize: '1rem'
                      })
                    }}
                  />
                </div>
              )}

              <Button
                variant="outline"
                className="h-14 px-6 text-base font-semibold rounded-xl shadow-sm hover:shadow-md transition-all gap-2 w-full sm:w-auto"
                onClick={() => history.push('/ContentStrategySettings')}>
                <Lightbulb className="h-5 w-5" />
                Content Settings
              </Button>
              {hasProPlan && (
                <Button
                  className="bg-primary hover:bg-primary/90 text-primary-foreground h-14 px-8 text-base font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all gap-3 w-full sm:w-auto"
                  onClick={handleCreateNewPost}>
                  <Plus className="h-5 w-5" />
                  New Post
                </Button>
              )}
            </div>
            {isSuperAdmin &&
              (customerList.length === 0 ? (
                <LoadingSpinner />
              ) : (
                <div className="flex w-full items-center justify-end">
                  <div className="inline-flex items-center rounded-xl border bg-muted/50 p-1 shadow-sm">
                    <div className="inline-flex items-center rounded-lg bg-background/80 p-0.5">
                      <Button
                        variant="ghost"
                        size="sm"
                        className={
                          `h-8 px-3 text-xs sm:text-sm rounded-md transition-all ` +
                          (clientNavigationMode === 'all'
                            ? 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90'
                            : 'text-muted-foreground hover:text-foreground')
                        }
                        onClick={() => setClientNavigationMode('all')}>
                        All Clients
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        className={
                          `h-8 px-3 text-xs sm:text-sm rounded-md transition-all ` +
                          (clientNavigationMode === 'no_ai'
                            ? 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90'
                            : 'text-muted-foreground hover:text-foreground')
                        }
                        onClick={() => setClientNavigationMode('no_ai')}
                        disabled={noAIClientList.length === 0}>
                        No AI Clients ({noAIClientList.length})
                      </Button>
                    </div>

                    {/* <div className="mx-2 h-6 w-px bg-border" /> */}

                    <div className="flex items-center gap-1">
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-10 w-10"
                        disabled={
                          navigableCustomerList.findIndex(
                            (customer) => customer.id === selectedClient.id
                          ) === 0
                        }
                        onClick={() => {
                          let x = navigableCustomerList.findIndex(
                            (customer) => customer.id === selectedClient.id
                          );
                          if (x > 0) {
                            handleChangeClient(navigableCustomerList[x - 1]);
                          }
                        }}>
                        <ChevronLeft className="h-5 w-5" />
                      </Button>
                      <span className="text-base font-medium text-foreground min-w-[60px] text-center">
                        {navigableCustomerList.length > 0
                          ? `${
                              navigableCustomerList.findIndex(
                                (customer) => customer.id === selectedClient.id
                              ) + 1
                            }/${navigableCustomerList.length}`
                          : '0/0'}
                      </span>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-10 w-10"
                        disabled={
                          navigableCustomerList.findIndex(
                            (customer) => customer.id === selectedClient.id
                          ) >=
                          navigableCustomerList.length - 1
                        }
                        onClick={() => {
                          let x = navigableCustomerList.findIndex(
                            (customer) => customer.id === selectedClient.id
                          );
                          if (x < navigableCustomerList.length - 1) {
                            handleChangeClient(navigableCustomerList[x + 1]);
                          }
                        }}>
                        <ChevronRight className="h-5 w-5" />
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* Calendar Card */}
        <Card className="shadow-md rounded-2xl border-0 overflow-hidden">
          <CardHeader className="pb-4 sm:pb-6 pt-4 sm:pt-8 px-3 sm:px-6 lg:px-10">
            {/* Top row: Title and filters */}
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 lg:gap-4 mb-4 sm:mb-6">
              <div className="flex items-center gap-2 sm:gap-4">
                <div className="h-10 w-10 sm:h-14 sm:w-14 rounded-xl bg-primary/10 flex items-center justify-center">
                  <CalendarIcon className="h-5 w-5 sm:h-7 sm:w-7 text-primary" />
                </div>
                <CardTitle className="text-lg sm:text-2xl lg:text-3xl font-bold">
                  Calendar
                </CardTitle>
              </div>
              <div className="flex items-center gap-3 sm:gap-8 flex-wrap">
                {/* Trash checkbox */}
                {hasProPlan && (
                  <label className="flex items-center gap-3 cursor-pointer">
                    <Checkbox
                      className="h-5 w-5 border-[#3767A9] [&[data-state=checked]]:bg-[#3767A9] [&[data-state=checked]]:border-[#3767A9]"
                      checked={checkDeleteMultiple}
                      onCheckedChange={checkDeleteMultipleState}
                    />
                    <span className="text-base text-muted-foreground">
                      {listSelectedToDelete.length}
                    </span>
                    <button
                      onClick={deletePostMultiple}
                      disabled={listSelectedToDelete.length === 0}
                      className="hover:opacity-70 transition-opacity disabled:cursor-not-allowed"
                      title="Delete selected posts">
                      <Trash2
                        className="h-5 w-5"
                        style={{ color: '#3767A9' }}
                      />
                    </button>
                  </label>
                )}

                {/* Magic wand checkbox */}
                {hasProPlan && (
                  <label className="flex items-center gap-3 cursor-pointer">
                    <Checkbox
                      className="h-5 w-5 border-[#3767A9] [&[data-state=checked]]:bg-[#3767A9] [&[data-state=checked]]:border-[#3767A9]"
                      checked={checkSwitchMultiple}
                      onCheckedChange={checkSwitchMultipleState}
                    />
                    <span className="text-base text-muted-foreground">
                      {listSelectedtoSwitch.length}
                    </span>
                    <button
                      onClick={updatePostsMultiple}
                      disabled={listSelectedtoSwitch.length === 0}
                      className="hover:opacity-70 transition-opacity disabled:cursor-not-allowed"
                      title="Toggle draft status for selected posts">
                      <Wand2 className="h-5 w-5" style={{ color: '#3767A9' }} />
                    </button>
                  </label>
                )}

                {/* View toggle - these will work through FullCalendar's API */}
                <div className="flex bg-muted/50 border p-1 sm:p-1.5 rounded-xl w-full sm:w-auto">
                  <Button
                    variant="ghost"
                    size="sm"
                    className="rounded-lg px-2 sm:px-5 py-1.5 sm:py-2 text-xs sm:text-base flex-1 sm:flex-none"
                    onClick={() =>
                      calendarRef.current?.getApi().changeView('dayGridMonth')
                    }>
                    Month
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="rounded-lg px-2 sm:px-5 py-1.5 sm:py-2 text-xs sm:text-base flex-1 sm:flex-none"
                    onClick={() =>
                      calendarRef.current?.getApi().changeView('dayGridWeek')
                    }>
                    Week
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="rounded-lg px-2 sm:px-5 py-1.5 sm:py-2 text-xs sm:text-base flex-1 sm:flex-none"
                    onClick={() =>
                      calendarRef.current?.getApi().changeView('dayGridDay')
                    }>
                    Day
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="rounded-lg px-2 sm:px-5 py-1.5 sm:py-2 text-xs sm:text-base flex-1 sm:flex-none"
                    onClick={() =>
                      calendarRef.current?.getApi().changeView('listMonth')
                    }>
                    List
                  </Button>
                </div>
              </div>
            </div>

            {/* Bottom row: Navigation and actions */}
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div className="flex items-center gap-4">
                <Button
                  variant="outline"
                  size="icon"
                  onClick={() => calendarRef.current?.getApi().prev()}
                  className="rounded-lg h-11 w-11">
                  <ChevronLeft className="h-5 w-5" />
                </Button>
                <Button
                  variant="outline"
                  size="icon"
                  onClick={() => calendarRef.current?.getApi().next()}
                  className="rounded-lg h-11 w-11">
                  <ChevronRight className="h-5 w-5" />
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => calendarRef.current?.getApi().today()}
                  className="rounded-lg h-11 px-5 text-base">
                  Today
                </Button>
              </div>

              <h2 className="text-lg sm:text-2xl font-bold text-foreground">
                {(() => {
                  try {
                    const [mStr, yStr] = String(queryDate || '').split(' ');
                    const monthIdx = Math.max(0, (Number(mStr) || 1) - 1);
                    const year = Number(yStr) || new Date().getFullYear();
                    const monthName = new Date(
                      year,
                      monthIdx,
                      1
                    ).toLocaleString('en-US', { month: 'long' });
                    return `${monthName} ${year}`;
                  } catch (_) {
                    return queryDate;
                  }
                })()}
              </h2>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-4">
                <Button
                  variant="outline"
                  className="rounded-lg h-11 px-5 text-base"
                  onClick={handleShowImages}>
                  <Image className="h-5 w-5 mr-2" />
                  {showImages ? 'Hide Images' : 'Show Images'}
                </Button>
                {hasProPlan && (
                  <Button
                    size="lg"
                    className="rounded-xl px-8 h-12 bg-gradient-to-r from-gray-700 to-gray-900 hover:from-gray-800 hover:to-black text-white font-semibold shadow-lg hover:shadow-xl transition-all border-0 text-base"
                    onClick={async () => {
                      if (isContentAgentProcessing) return;

                      setIsContentAgentProcessing(true);

                      try {
                        let monthName;
                        try {
                          const [mStr] = String(queryDate || '').split(' ');
                          const mIdx = Math.max(
                            0,
                            (Number(mStr) || new Date().getMonth() + 1) - 1
                          );
                          monthName = new Date(2000, mIdx, 1).toLocaleString(
                            'en-US',
                            { month: 'long' }
                          );
                        } catch (_) {
                          monthName = new Date().toLocaleString('en-US', {
                            month: 'long'
                          });
                        }
                        const payload = {
                          clientId: selectedClient.id,
                          monthName,
                          realImages: true
                        };

                        const hasNoAIFlag =
                          selectedClient?.clientFlags?.includes('NO_AI');

                        const apiEndpoint = hasNoAIFlag
                          ? API_GENERATE_AI_POST_V2_NO_AI
                          : API_GENERATE_AI_POST_V2;

                        setIsGenerating(true);
                        SetLoadingPosts(true);
                        setBlockingClientId(selectedClient.id);
                        const startedAtNow = Date.now();
                        setGenerationStartTime(startedAtNow);

                        const qs = new URLSearchParams({
                          clientId: String(payload.clientId || ''),
                          monthName: String(payload.monthName || ''),
                          realImages: String(payload.realImages)
                        }).toString();
                        const url = `${apiEndpoint}?${qs}`;

                        fetch(url, { method: 'GET' }).catch((err) => {
                          console.error('Error in background request:', err);
                        });

                        const pollForGenerationStart = () => {
                          const pollInterval = setInterval(async () => {
                            try {
                              const clientResponse = await axios.get(
                                `${API_CLIENTS_NAME}${selectedClient?.clientName}`,
                                {
                                  headers: {
                                    'X-API-KEY': API_KEY,
                                    Authorization: `bearer ${userInfo.accessToken}`
                                  }
                                }
                              );

                              if (
                                clientResponse.data.generatingContentByAI ===
                                true
                              ) {
                                clearInterval(pollInterval);
                                dispatch(
                                  setSelectedClient(clientResponse.data)
                                );
                                await new Promise((resolve) =>
                                  setTimeout(resolve, 150)
                                );
                                window.location.reload();
                              }
                            } catch (pollError) {
                              console.error(
                                'Error polling for generation status:',
                                pollError
                              );
                            }
                          }, 200);

                          setTimeout(() => {
                            clearInterval(pollInterval);
                            window.location.reload();
                          }, 10000);
                        };

                        setTimeout(pollForGenerationStart, 200);
                      } catch (err) {
                        console.error('Error generating AI content v2', err);
                        setIsContentAgentProcessing(false);
                      }
                    }}
                    disabled={isContentAgentProcessing}>
                    <Sparkles className="h-5 w-5 mr-2" />
                    {isContentAgentProcessing
                      ? 'Processing...'
                      : 'Generate Content'}
                  </Button>
                )}
              </div>
            </div>
          </CardHeader>
          <CardContent
            className={
              'px-6 lg:px-10 pb-10 flex-1 flex flex-col ' +
              (loadingPosts || isGenerating
                ? 'opacity-50 pointer-events-none'
                : '')
            }
            style={{
              pointerEvents: loadingPosts || isGenerating ? 'none' : 'auto'
            }}>
            <div className="flex-1">
              <FullCalendar
                ref={calendarRef}
                scrollTime={false}
                columnHeaderFormat={
                  window.innerWidth < 640
                    ? { weekday: 'short' }
                    : { weekday: 'long' }
                }
                defaultView="dayGridMonth"
                selectable={true}
                eventLimit={false}
                handleWindowResize={true}
                aspectRatio={1.5}
                expandRows={false}
                contentHeight={'auto'}
                displayEventTime={!showPrompts && !loadingPosts}
                fixedWeekCount={false}
                showNonCurrentDates={false}
                themeSystem={'standard'}
                eventRender={(info) => {
                  if (info.view.type === 'dayGridMonth') {
                    const eventTitle = info.event.title || '';

                    const hasLineBreak =
                      eventTitle.includes('\n') ||
                      (eventTitle.includes('**Q:') &&
                        eventTitle.includes('**A:')) ||
                      eventTitle.includes('A: Look for missing shingle') ||
                      eventTitle.includes('Is your commercial roof');

                    if (hasLineBreak) {
                      info.el.setAttribute('data-has-line-break', 'true');
                    }
                  }

                  // List view with images functionality
                  if (info.view.type === 'listMonth') {
                    const titleTd = info.el.querySelector(
                      '.fc-list-item-title'
                    );
                    const reactContainer = document.createElement('div');
                    ReactDOM.render(
                      <CustomListContent obj={info.event} ev={info} />,
                      reactContainer
                    );
                    titleTd.style.display = 'flex';
                    titleTd.style.justifyContent = 'space-between';
                    reactContainer.style.display = 'flex';
                    reactContainer.style.alignItems = 'center';
                    titleTd.appendChild(reactContainer);
                  }
                  // Show images functionality
                  if (
                    info.view.type === 'dayGridMonth' &&
                    showImages &&
                    !showPrompts
                  ) {
                    const eventEl = info.el;
                    const originalContent =
                      eventEl.querySelector('.fc-content');
                    const timeEl = originalContent?.querySelector('.fc-time');
                    const titleEl = originalContent?.querySelector('.fc-title');
                    const timeText = timeEl?.innerText || '';
                    const titleText = titleEl?.innerText || '';

                    // Add show-images-mode class for consistent styling
                    eventEl.classList.add('show-images-mode');

                    // Clear the original content
                    eventEl.innerHTML = '';

                    // Main container with fc-content class for proper styling
                    const wrapper = document.createElement('div');
                    wrapper.className = 'fc-content show-images-mode';
                    wrapper.style.display = 'flex';
                    wrapper.style.flexDirection = 'column';
                    wrapper.style.alignItems = 'flex-start';
                    wrapper.style.justifyContent = 'start';
                    wrapper.style.overflow = 'hidden';
                    wrapper.style.padding = '2px';
                    wrapper.style.height = '100%';
                    wrapper.style.maxHeight = '100px';

                    // Text container with proper class
                    const textContainer = document.createElement('div');
                    textContainer.className = 'text-container';
                    // Ensure only first line is shown by truncating at reasonable length
                    const fullText = `${timeText} ${titleText}`;
                    const truncatedText =
                      fullText.length > 50
                        ? fullText.substring(0, 50) + '...'
                        : fullText;
                    textContainer.innerText = truncatedText;

                    // Imagen
                    const img = document.createElement('img');
                    img.src = info.event.extendedProps.images?.[0]?.url || '';
                    img.alt = '';
                    img.style.maxHeight = '80px';
                    img.style.width = '100%';
                    img.style.objectFit = 'cover';
                    img.style.display = 'block';

                    wrapper.appendChild(textContainer);
                    if (!img.src.includes('/calendar') && img.src) {
                      wrapper.appendChild(img);
                    }
                    eventEl.appendChild(wrapper);
                  }
                  // Commented out to restore original calendar aesthetics
                  // if (!showPrompts) return;
                  // if (info.view.type === 'dayGridMonth' && showPrompts) {
                  //   const eventElement = info.el;
                  //   const content = eventElement.querySelector('.fc-content');
                  //   content.classList.add('fc-content-custom');
                  // }
                }}
                customButtons={{
                  ...(true && {
                    customTitle: {
                      text: `Prompts${
                        contentStrategy?.strategyName !== undefined
                          ? ' - ' + contentStrategy?.strategyName
                          : ''
                      }`
                    }
                  })
                }}
                height={'auto'}
                buttonIcons={{
                  prev: 'left-single-arrow',
                  next: 'right-single-arrow',
                  prevYear: 'left-double-arrow',
                  nextYear: 'right-double-arrow'
                }}
                views={{
                  FourDayView: {
                    type: 'timeGrid',
                    duration: { days: 4 },
                    buttonText: '4 day'
                  },
                  YearView: {
                    type: 'timeline',
                    buttonText: 'year',
                    dateIncrement: { years: 1 },
                    slotDuration: { months: 1 },
                    duration: { year: 1 }
                  }
                }}
                eventClick={onSelectPost}
                eventDrop={(event) => {
                  if (showPrompts) return;
                  let start;
                  if (typeof event.event.start === 'object') {
                    start = new Date(event.event.start).getTime();
                    start = start / 1000;
                    start = Math.floor(start);
                  } else {
                    start = event.event.start;
                  }
                  let getIdxPost = () => {
                    let idx = 0;
                    while (postsLists[idx].id !== event.event.id) {
                      idx++;
                    }
                    return idx;
                  };
                  let isDraft = false;
                  let posted = false;
                  let isScheduled = false;
                  if (event.event.extendedProps.status === 'Draft') {
                    isDraft = true;
                  } else if (event.event.extendedProps.status === 'Posted') {
                    posted = true;
                  } else if (event.event.extendedProps.status === 'Scheduled') {
                    isScheduled = true;
                  } else {
                  }
                  let post = {
                    message: event.event.title,
                    images: event.event.extendedProps.images,
                    schedule: start,
                    createdAt: event.event.extendedProps.createdAt,
                    socialNetworks: event.event.extendedProps.socialNetworks,
                    isDraft,
                    recurrentDates: [],
                    posted,
                    isScheduled,
                    createdBy: event.event.extendedProps.createdBy,
                    clientId: selectedClient.id,
                    postId: event.event.id
                  };
                  let newPostsList = postsLists;
                  let idx = getIdxPost();

                  newPostsList[idx] = post;
                  SetPostsLists(newPostsList);
                  dispatch(showLoading());
                  SetLoadingPosts(true);
                  axios
                    .post(API_POSTS_EDIT, JSON.stringify(post))
                    .then((response) => {
                      fetchPosts(queryDate);
                    })
                    .catch((error) => {
                      fetchPosts(queryDate);
                      if (error) {
                        setScheduleErrorModalOpen(true);
                      }
                      console.error(error);
                    });
                }}
                buttonText={{
                  today: 'Today',
                  month: 'Month',
                  dayGridWeek: 'Week',
                  day: 'Day',
                  list: 'List'
                }}
                header={{
                  left: '',
                  center: `${showPrompts ? 'customTitle' : ''}`,
                  right: ''
                }}
                plugins={[
                  dayGridPlugin,
                  timeGridPlugin,
                  interactionPlugin,
                  timeline,
                  list
                ]}
                events={(fetchInfo, successCallback, failureCallback) =>
                  getCalendarDate(fetchInfo, successCallback, failureCallback)
                }
                dateClick={handleDateClick}
                forceEventDuration={true}
                defaultTimedEventDuration={{ minutes: 1 }}
              />
            </div>
          </CardContent>
        </Card>

        <ViewPostsInCalendar
          ref={viewPostRef}
          show={showViewPostModal}
          onClose={() => setShowViewPostModal(false)}
          contentStrategy={contentStrategy}
          userRole={userInfo}
          posts={postsLists}
          selectedClient={selectedClient}
          carrouselModal={carrouselModal}
          updatePost={updatePost}
          handleShowPrompts={handleShowPrompts}
          deletePost={(id, options) => {
            deletePost(id, options);
          }}
          editPost={(post) => {
            editPost(post);
          }}
          rePost={(post) => {
            rePost(post);
          }}
          repairPost={(post) => {
            repairPost(post);
          }}
          IAPostTools={() => {
            handleClickIATools();
          }}
          post={selectedPost}
          timeZone={getTime(
            selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)'
          )}
          time={selectedClient.timeZone || 'Eastern Daylight Time - (GMT-4)'}
          getStatusPost={getStatusPost}
          close={() => {
            setShowViewPostModal(false);
            dispatch(setSelectedPost());
          }}
        />

        {/* Modal flotante para el contador de generación AI */}
        {isGenerating && blockingClientId === selectedClient?.id && (
          <Countdown
            selectedClient={selectedClient}
            generationStartTime={generationStartTime}
            onComplete={() => {
              setIsGenerating(false);
              SetLoadingPosts(false);
              setBlockingClientId(null);
              setGenerationStartTime(null);
              dispatch(resetContentState());
            }}
          />
        )}

        {/* Delete Confirmation Modal */}
        <Dialog
          open={deleteConfirmModalOpen}
          onOpenChange={setDeleteConfirmModalOpen}>
          <DialogContent className="sm:max-w-md text-center py-10">
            <DialogHeader className="items-center">
              <DialogTitle className="text-2xl font-bold text-foreground">
                Delete Posts
              </DialogTitle>
              <DialogDescription className="text-base text-muted-foreground mt-2">
                Are you sure you want to delete these posts?
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center gap-4 mt-4">
              <Button
                variant="outline"
                className="px-8 h-11 text-base font-semibold rounded-lg"
                onClick={() => setDeleteConfirmModalOpen(false)}>
                Cancel
              </Button>
              <Button
                className="bg-red-500 hover:bg-red-600 text-white px-8 h-11 text-base font-semibold rounded-lg"
                onClick={confirmDeletePostMultiple}>
                Delete
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Update Confirmation Modal */}
        <Dialog
          open={updateConfirmModalOpen}
          onOpenChange={setUpdateConfirmModalOpen}>
          <DialogContent className="sm:max-w-md text-center py-10">
            <DialogHeader className="items-center">
              <DialogTitle className="text-2xl font-bold text-foreground">
                Switch Post Status
              </DialogTitle>
              <DialogDescription className="text-base text-muted-foreground mt-2">
                Are you sure you want to switch these posts status?
                <br />
                (Draft ↔ Scheduled)
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center gap-4 mt-4">
              <Button
                variant="outline"
                className="px-8 h-11 text-base font-semibold rounded-lg"
                onClick={() => setUpdateConfirmModalOpen(false)}>
                Cancel
              </Button>
              <Button
                className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                onClick={confirmUpdatePostsMultiple}>
                Confirm
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Delete Success Modal */}
        <Dialog
          open={deleteSuccessModalOpen}
          onOpenChange={setDeleteSuccessModalOpen}>
          <DialogContent className="sm:max-w-md text-center py-10">
            <DialogHeader className="items-center">
              <DialogTitle className="text-2xl font-bold text-foreground">
                Success!
              </DialogTitle>
              <DialogDescription className="text-base text-muted-foreground mt-2">
                Selected posts have been deleted successfully.
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center mt-4">
              <Button
                className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                onClick={() => setDeleteSuccessModalOpen(false)}>
                OK
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Update Success Modal */}
        <Dialog
          open={updateSuccessModalOpen}
          onOpenChange={setUpdateSuccessModalOpen}>
          <DialogContent className="sm:max-w-md text-center py-10">
            <DialogHeader className="items-center">
              <DialogTitle className="text-2xl font-bold text-foreground">
                Success!
              </DialogTitle>
              <DialogDescription className="text-base text-muted-foreground mt-2">
                Draft status has been toggled for selected posts.
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center mt-4">
              <Button
                className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                onClick={() => setUpdateSuccessModalOpen(false)}>
                OK
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Post Sent Success Modal */}
        <Dialog
          open={postSentSuccessModalOpen}
          onOpenChange={setPostSentSuccessModalOpen}>
          <DialogContent className="sm:max-w-md text-center py-10">
            <DialogHeader className="items-center">
              <DialogTitle className="text-2xl font-bold text-foreground">
                Success!
              </DialogTitle>
              <DialogDescription className="text-base text-muted-foreground mt-2">
                Your post has been sent successfully
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center mt-4">
              <Button
                className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                onClick={() => setPostSentSuccessModalOpen(false)}>
                OK
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Schedule Error Modal */}
        <Dialog
          open={scheduleErrorModalOpen}
          onOpenChange={setScheduleErrorModalOpen}>
          <DialogContent className="sm:max-w-md text-center py-10">
            <DialogHeader className="items-center">
              <DialogTitle className="text-2xl font-bold text-foreground">
                Error!
              </DialogTitle>
              <DialogDescription className="text-base text-muted-foreground mt-2">
                We have trouble scheduling the publication.
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center mt-4">
              <Button
                className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                onClick={() => setScheduleErrorModalOpen(false)}>
                OK
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </main>
    </>
  );
}

export default CalendarScreen;
